import { Table } from '@material-ui/core'
import { Indicadores } from 'models/Viabilidade/Indicadores'
import NumberFormat from 'react-number-format'
import {
  TableContainerCustomizado,
  TableCellLabel,
  TableRowAlternada,
  TableRowVerde,
  TableCellValor,
  TableCellBold,
  TableCellBoldAlignRight
} from '../index.style'
import { parsePorcentagem } from 'helpers/formatador'

const CartaoIndicadores: React.FC<{ dados: Indicadores; custoCasa: string }> = ({ dados, custoCasa }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableIndicadores">
        <TableRowAlternada>
          <TableCellLabel>Custo Casa(R$/unid)</TableCellLabel>
          <TableCellValor data-cy="campoResultadoCustoCasa">
            <NumberFormat
              value={custoCasa}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Área de Lazer - ASC (R$/unid)</TableCellLabel>
          <TableCellValor data-cy="campoAreaLazerAsc">
            <NumberFormat
              value={dados.areaLazerAsc}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Total Muro Externo Condomínio (R$/unid)</TableCellLabel>
          <TableCellValor data-cy="campoTotalMuroExternoCondominio">
            <NumberFormat
              value={dados.totalMuroExternoCondominio}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Total Muro Interno (R$/unid)</TableCellLabel>
          <TableCellValor data-cy="campoTotalMuroInterno">
            <NumberFormat
              value={dados.totalMuroInterno}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Viário Interno Condomínio (R$/unid)</TableCellLabel>
          <TableCellValor data-cy="campoViarioInternoCondominio">
            <NumberFormat
              value={dados.viarioInternoCondominio}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              decimalScale={0}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowVerde>
          <TableCellBold>Custo Total da Casa (R$/unid)</TableCellBold>
          <TableCellBoldAlignRight data-cy="campoCustoTotalCasa">
            <NumberFormat
              value={dados.custoTotalCasa}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellBoldAlignRight>
        </TableRowVerde>
        <TableRowAlternada>
          <TableCellLabel>Duration</TableCellLabel>
          <TableCellValor data-cy="campoIndiceDuration">
            <NumberFormat
              value={dados.indiceDuration}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>CA da MRV</TableCellLabel>
          <TableCellValor data-cy="campoCaMrv">
            <NumberFormat
              value={dados.caMrv}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Adensamento (m²)</TableCellLabel>
          <TableCellValor data-cy="campoAdensamentoMetroQuadrado">
            <NumberFormat
              value={dados.adensamentoMetroQuadrado}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Adensamento (%)</TableCellLabel>
          <TableCellValor data-cy="campoAdensamentoPorcentagem">
            <NumberFormat
              value={parsePorcentagem(dados.adensamentoPorcentagem as string)}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              suffix="%"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Fração Contábil</TableCellLabel>
          <TableCellValor data-cy="campoFracaoContabil">
            <NumberFormat
              value={dados.fracaoContabil}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Fração Gerencial</TableCellLabel>
          <TableCellValor data-cy="campoFracaoGerencial">
            <NumberFormat
              value={dados.fracaoGerencial}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoIndicadores
